import { IGeneralInfo } from '../types/app'
import { getStorageKey } from './appType'

export function getGeneralInfo(): Partial<IGeneralInfo> {
  try {
    return JSON.parse(localStorage.getItem(getStorageKey('info')) || '{}')
  } catch {
    return {}
  }
}
